import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBecepsRightArm: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="beceps-right-arm, strong, flex, power"><path d="M10.8309 2C14.4999 2 14.0005 7.99944 10.0009 7C7.50096 10.9999 9.36809 12 7.99989 15C9.33034 13.8596 10.801 13.0201 12.327 13.0312C15.0008 8.00025 22.0025 9.67814 21.9999 14.9502C21.9998 23.7105 7.40913 23.1583 2.33192 19.4707C0.678051 10.0703 5.46973 2.00035 10.8309 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBecepsRightArm;
